import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';

import { getQuote } from '../../actions/index';
import { db } from './../../config/firebaseConfig';

class HeroSection extends React.Component {

  recaptchaRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      hero: {},
      trustedCompany: [],
      video: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      isAgreed: false,
      disableBtn: false,
      btnText: "Enviar",
      validationErrorMessage: "",
      successSubmitted : false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  

  changeBtnText = btnText => {
    this.setState({ btnText });
  };

  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(stateValue);
  }

  formValidations(name,email,phone,message){

    const initialNumber = phone.charAt(0);
    const threeFirstsNumber = phone.substr(0,3);
    const nineRemainNumbers = phone.substr(3);
    const recaptchaValue = this.recaptchaRef.current;
    if(!recaptchaValue.getValue()){
      this.setState({ validationErrorMessage: "Error: verifica que no eres un robot" });
      return false
    }
    if(name === "" || email === "" || phone === "" || message === ""){
      this.setState({ validationErrorMessage: "Error: Todos los campos son obligatorios" });
      return false
    };
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){
      this.setState({ validationErrorMessage: "Error: Debe ingresar un email válido" });
      return false
    }
    if(isNaN(phone)){
      this.setState({ validationErrorMessage: "Error: Se debe digitar un numero válido" });
      return false;
    }
    if(!this.state.isAgreed){
      this.setState({ validationErrorMessage: "Error: Debe aceptar los terminos y condiciones" });
      return false;
    }
    if (initialNumber === '0' && !(phone.length === 10)){
      this.setState({ validationErrorMessage: "Error: El número telefónico debe tener 10 dígitos" });
      return false;
    }else if(threeFirstsNumber === '593' && !(nineRemainNumbers.length === 9)){
      this.setState({ validationErrorMessage: "Error: El número telefónico debe tener 9 dígitos apartir del 593" });
      return false;
    }
    recaptchaValue.reset();
    this.setState({ validationErrorMessage: "" });
    return true;
  }

  saveMerchantData = async () =>{
    await db.collection('merchant-contact-form').doc().set({
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
      isAgreed: this.state.isAgreed,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const name = this.state.name;
    const email = this.state.email;
    const phone = this.state.phone;
    const message = this.state.message;

    if(!this.formValidations(name,email,phone,message)) return;

    this.changeBtnText("Sending...");
    // disable the button
    this.setState({ disableBtn: true });

    // // get action
    const quoteAction = getQuote(this.state);

    // // Dispatch the contact from data
    this.props.dispatch(quoteAction);

    // // added delay to change button text to previous
    setTimeout(
      function() {
        // enable the button
        this.setState({ disableBtn: false });

        // change to button name
        this.changeBtnText("Enviar");

        // get action again to update state
        const quoteAction = getQuote(this.state);

        // Dispatch the contact from data
        this.props.dispatch(quoteAction);

        this.saveMerchantData();

        this.setState({successSubmitted: true});
        setTimeout( () =>{
          this.setState({ successSubmitted : false});
        },3000)

        // clear form data
        this.setState({
          name: "",
          email: "",
          phone: "",
          message: "",
          isAgreed: false
        });
      }.bind(this),
      3000
    );
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="hero-section background-img pt-100"
          style={{
            backgroundImage: "url('img/hero-bg-4.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-6 col-lg-6">
                <div className="hero-content-left position-relative mt-lg-0 mt-md-0 mt-5 text-white">
                  <h1 className="text-white">
                    <span>Vende más y mejor</span> con nuestra app
                  </h1>
                  <p className="lead">
                    Te presentamos Frisbee Mobile Shopping. La primera app que es eCommerce y Red Social, para acercar tus productos a tus clientes.
                    Ofrecemos soluciones operativas, comerciales y tecnológicas que se traduce en experiencia para nuestros clientes. 
                    Sube tus productos, vende online, controla tu negocio y enamora a tus clientes.
                  </p>

                  <div className="video-promo-content mt-4 d-flex align-items-center">
                    <a
                      href="https://www.youtube.com/watch?v=9No-FiEInLA"
                      className="popup-youtube video-play-icon"
                      crossorigin="anonymous"
                    >
                      <span className="ti-control-play"></span>{" "}
                    </a>
                    <span className="ml-4">Mira cómo funciona</span>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-5">
                <div className="sign-up-form-wrap position-relative rounded p-5 gray-light-bg mt-5">
                  <div className="sign-up-form-header text-center mb-4">
                    <h4 className="mb-0">Conoce nuestros servicios</h4>
                    <p>Te respondemos en menos de 12 horas.</p>
                  </div>
                  <form
                    method="post"
                    className="sign-up-form"
                    onSubmit={this.handleSubmit}
                  >
                    <div className="form-group input-group">
                      <input
                        value={this.state.name}
                        onChange={e => this.handleFormValueChange("name", e)}
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Nombre y Apellido"
                      />
                    </div>
                    <div className="form-group input-group">
                      <input
                        value={this.state.email}
                        onChange={e => this.handleFormValueChange("email", e)}
                        type="text"
                        name="email"
                        className="form-control"
                        placeholder="Email Corporativo"
                      />
                    </div>
                    <div className="form-group input-group">
                      <input
                        value={this.state.phone}
                        onChange={e => this.handleFormValueChange("phone", e)}
                        type="text"
                        name="phone"
                        className="form-control"
                        placeholder="Teléfono"
                      />
                    </div>
                    <div className="form-group input-group">
                      <textarea
                        onChange={e => this.handleFormValueChange("message", e)}
                        value={this.state.message}
                        name="message"
                        id="msg"
                        className="form-control"
                        placeholder="Mensaje Adicional"
                        cols="30"
                        rows="4"
                      ></textarea>
                    </div>
                    <div className="form-group">
                       <button
                        type="submit"
                        name="submit"
                        className="btn solid-btn btn-block"
                        id="btnContactUs"
                        disabled={this.state.disableBtn}
                      >
                        {this.state.btnText}
                      </button>
                    </div>
                    <div className="form-check d-flex align-items-center text-center ml-4">
                      <input
                        checked={this.state.isAgreed}
                        onChange={e =>
                          this.handleFormValueChange("isAgreed", e)
                        }
                        type="checkbox"
                        name="isAgreed"
                        className="form-check-input mt-0 mr-3"
                        id="ckbAgree"
                      />
                      <label className="form-check-label" htmlFor="ckbAgree">
                        Acepto los <a href="/#">términos y condiciones</a>
                      </label>
                    </div>
                    <div className= "mt-3 mt-1 d-flex justify-content-center">
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size={'compact'}
                      sitekey={ 
                        process.env.NODE_ENV === "development" ? 
                        process.env.REACT_APP_SITE_KEY_LOCAL_RECAPTCHA :
                        process.env.REACT_APP_SITE_KEY_PROD_RECAPTCHA
                      }
                      onChange={this.onChange}
                    />
                    </div>
                  </form>
                  <p>{this.state.validationErrorMessage}</p>
                  { this.state.successSubmitted ? <span class="badge badge-pill badge-success ml-2">Enviado!</span> : null }
                </div>
              </div>
            </div>
          </div>
          <div className="section-shape position-absolute">
            <img src="img/wave-shap.svg" alt="shape" />
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(HeroSection);
